export const WP_URL = "http://localhost/sa9e-cms"
export const WP_API_URL = "https://api.soimagine.co.za/wp-json/sa9ecms/v1"
export const WP_USER = "SA9E "
export const WP_PASS = "Sa9eReaktion"
export const WP_API_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwOi8vbG9jYWxob3N0L3NhOWUtY21zIiwiaWF0IjoxNzEyMjE5NTUyLCJuYmYiOjE3MTIyMTk1NTIsImV4cCI6MTcxMjgyNDM1MiwiZGF0YSI6eyJ1c2VyIjp7ImlkIjoiMSJ9fX0.SvRPY9DTQXr3SmXT9SCi-nCj8HcyWEWX2F7eu6_Iitw "